import { render } from "./photo.vue?vue&type=template&id=e1c600be"
import script from "./photo.vue?vue&type=script&lang=js"
export * from "./photo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\vant\\lan_v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__